import type { TCriarPropostaResponse, TPropostaData } from '@/features/proposta/interfaces/proposta.type'
import { HttpService } from '@/shared/lib/http'

export class CriarProposta extends HttpService {
  execute = async (proposta: TPropostaData) => {
    const response = await this.http.post<TCriarPropostaResponse>(`/api/v2/Proposta`, proposta)
    return response.data
  }
}
